import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { moveToNextOrDefaultPage, moveToLoginWithNext } from '../commons/query';
import { getCustomerFromApi } from '../cadastro/api';

class AcessoComponent extends Component {
  render() {
    return null;
  }

  componentWillMount() {
    this.makeLoginAndRedirect();
  }

  async makeLoginAndRedirect() {
    try {
      const customerResponse = await getCustomerFromApi();

      if (customerResponse.status === 200) {
        moveToNextOrDefaultPage(this.props.history.push);
      } else {
        throw new Error('Usuário não autenticado');
      }
    } catch (error) {
      moveToLoginWithNext(this.props.history.push);
    }
  }
}

class AcessoContainer extends React.Component {
  render() {
    return (
      <Switch>
        <Route path="/acesso" children={() => <AcessoComponent history={this.props.history} />} />
        <Redirect to="/acesso" />
      </Switch>
    );
  }
}

export default withRouter(AcessoContainer);
